var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import DescriptionHeading from "./descriptionHeading";
import * as styles from "./styles.css";
var DescriptionColumnHeading = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(DescriptionHeading, __assign({ className: styles.descriptionColumnHeading, weight: "regular" }, rest), children));
};
export default DescriptionColumnHeading;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/description/descriptionColumnHeading.tsx
// module id = A7M+
// module chunks = 2